import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import Heading from '../../Components/Heading/Heading';
import { getAllusers, get_all_placed_orders } from '../../Services/APIService';
import { FilterData } from '../../Components/FilterData/FilterData';
import Filter  from '../../Components/FilterData/Filter';
import axios from 'axios';
import { Container, Grid } from '@mui/material';
import { orderTable, userTable } from '../../Variables/Variables';


export default function Users() {

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState();
  const [color, setColor] = useState();
  const [users, setUsers] = useState([]);
  const [search , setSearch] = useState('');
  
  useEffect(()=>{
      axios({
      method: "GET",
      url: getAllusers,
  }).then(res => {
        if (res.data.error) {
            setMessage(res.data.message)
            setOpen(true)
            setStatus(false)
            setColor(false)
        } else {
            setOpen(true)
            setMessage(res.data.message)
            setUsers(res.data.data);
            setStatus(true)
            setColor(true)
        }
    }).catch(err => {
        console.log(err)
    });
},[])
 


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };



  return (
    <Box p={2}>
        <Box p={3}>
            <Heading  title={'all customers'}/>
        </Box>
      <Container>
    <Box mt={2} py={4}  >
    <Grid container>
                    <TableContainer sx={{border:'1px solid silver'}} >

                    <Table>
                    <TableHead sx={{ whiteSpace: 'nowrap' , bgcolor:'#616e80' }}>
                    <TableRow sx={{borderBottom:'1px solid silver'}}>
                      {
                    userTable.map((i, index)=>{
                      return(
                     <TableCell sx={{ textAlign: 'center', color: 'white', fontWeight: 600  }}>
                    <Box sx={{ display: 'flex' , justifyContent:'center'}}>
                    <Box sx={{ my: 'auto' }}>
                      {i.title}
                    </Box>
                   <Box>{
                    i.filter &&
                              <Filter search={search} setSearch={setSearch} setPage={setPage} />
                    }
                   </Box>
                  </Box>
                    </TableCell>
                    )})
                    }
                    </TableRow>
                    </TableHead>


                    <TableBody>
                   
                      {
                        users.filter((data) =>FilterData(data, search, {
                                    searchFeildOne: data.userId,
                                    searchFeildTwo:data.email,
                                })).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((i,index)=>{
                          return(
                    <TableRow key={index} sx={{borderBottom:'1px solid silver'}}>
                    <TableCell sx={{textAlign:'center',borderBottom:'1px solid silver'}}>{i.userId}</TableCell>
                    <TableCell sx={{textAlign:'center',borderBottom:'1px solid silver'}}>{i.first_name}</TableCell>
                    <TableCell sx={{textAlign:'center',borderBottom:'1px solid silver'}}>{i.last_name}</TableCell>
                    <TableCell sx={{textAlign:'center',borderBottom:'1px solid silver'}}>{i.email}</TableCell>
                    <TableCell sx={{textAlign:'center',borderBottom:'1px solid silver'}}>{i.mobile}</TableCell>
                    <TableCell sx={{textAlign:'center',borderBottom:'1px solid silver'}}>{i.address} {i.city} {i.country} {i.pincode}</TableCell>
                    <TableCell sx={{textAlign:'center',borderBottom:'1px solid silver'}}>{i.province}</TableCell>
                    </TableRow>
                          )
                        })
                      }

                    </TableBody>
                    </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={users.length}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </Grid>
                  </Box>
                </Container>
    </Box>
  );
}